import { Pipe, PipeTransform } from '@angular/core';
import { MappingDependency } from '@classes/mapping/mapping-dependency';
import { MappingTree } from '@classes/mapping/mapping-tree';

@Pipe({
  name: 'mappingDisplayOrder'
})
export class MappingDisplayOrderPipe implements PipeTransform {

  transform(mappingItems: MappingTree[] | MappingDependency[], counter?: number): any[] {
    return mappingItems?.sort((a: MappingTree | MappingDependency, b: MappingTree | MappingDependency) => a.displayOrder > b.displayOrder ? 1 : -1);
  }

}
